import { Config } from "~/constants/configuration_provider";

export const getJunosInstallCommand = (
  tokenValue: string,
) => `export MONDOO_REGISTRATION_TOKEN='${tokenValue}'
curl -sSL https://${Config.VITE_INSTALL_HOST}/sh | bash -s -- -t $MONDOO_REGISTRATION_TOKEN`;
